import { dispatcher, DispatcherEvents } from "../dispatcher";
import { isIphone } from "./nativeHelpers";
import { Source as LogSource, log, error as errorLog } from "../logger";
import { IOpenCabEventDetail } from "../../model/OpenCab";

export function addNativeEventListeners() {
    window.addEventListener("batterystatus", function (e: any) {
        let info = e.detail as { isPlugged: boolean; level: string }; // CustomEvent from shell
        dispatcher.trigger(DispatcherEvents.StatusCharging, info.isPlugged);
        dispatcher.trigger(DispatcherEvents.StatusBattery, info.level); //no one listening to this event currently
    }, false);

    window.addEventListener("opencab.event", { handleEvent: (param: CustomEvent<IOpenCabEventDetail>) => dispatcher.trigger(DispatcherEvents.OpenCab, param.detail.action) });

    // native SDK connectivity event
    window.addEventListener("connectivity", function (param: any) {
        let state = param.detail as { online: boolean; type: string };
        dispatcher.trigger(DispatcherEvents.StatusOnline, state.online);
    });

    /* Only works within a nativeContainer */
    document.addEventListener("online", function () {
        dispatcher.trigger(DispatcherEvents.StatusOnline, true);
    }, false);

    document.addEventListener("offline", function () {
        dispatcher.trigger(DispatcherEvents.StatusOnline, false);
    }, false);

    // fix ios stuck inputs bug
    if (isIphone()) {
        let toggleInput = (evt) => {
            window.focus();
            evt.target.focus();
        };
        document.addEventListener("keydown", toggleInput, false);
    }

    document.addEventListener("backbutton", function () {
        window.history.back();
    }, false);

    window.addEventListener("app.log", function (event: any) {
        enum LogLevel { Info = 0, Warn, Error }
        let logDetail = event.detail as { message: string; level: LogLevel };
        if (logDetail && logDetail.message) {
            switch (logDetail.level) {
                case LogLevel.Info:
                    log(LogSource.NATIVE_SDK_INFO, logDetail.message);
                    break;
                case LogLevel.Warn:
                    log(LogSource.NATIVE_SDK_WARN, logDetail.message);
                    break;
                case LogLevel.Error:
                    errorLog(LogSource.NATIVE_SDK_ERROR, logDetail.message);
                    break;
                default:
                    break;
            }
        }
    }, false);
}
